import { apiClient } from './authService';

const centresService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/centres/?${queryParams}` : '/centres/';
    const response = await apiClient.get(url);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/centres/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    const response = await apiClient.post('/centres/', data, isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : undefined);
    return response.data;
  },

  update: async (id, data) => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    const response = await apiClient.put(`/centres/${id}/`, data, isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : undefined);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/centres/${id}/`);
    return response.data;
  },
};

export default centresService;
